/**
 * Adds an event listener to handle a specific key press.
 * When the specified key is pressed, the provided callback function is executed.
 *
 * @param {string} targetKey - The key to listen for (e.g., "Escape").
 * @param {Function} onKeyPress - Callback function to execute when the key is pressed.
 */
export const handleKeyPress = (targetKey, onKeyPress) => {
  const handleKeyDown = (event) => {
    if (event.key === targetKey) {
      onKeyPress();
    }
  };

  window.addEventListener("keydown", handleKeyDown);
  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
};
